export {
    productData
};
import i18n from '../i18n'

function productData(str) {
    return {
        Protection: {
            headerImg: 'centerSlide1',
            MainTitle: i18n.t("医疗防护类"),
            miniTitle: i18n.t("誉诚为您保驾护航"),
            itemList: [
                {
                    title: i18n.t("防护服"),
                    text: i18n.t("多种款式，专业防护"),
                    img: "ProtectionProductsClass1.jpg",
                    type:'fhf',
                    child:[
                        {
                            // 在产品列表里展示图片的名称
                            img:'fhf0',
                            name:i18n.t('防水防尘胶条防护服'),
                            type:'fhf',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("fhfText1"),
                                // 产品作用
                                use:i18n.t("fhfText2"),
                                // 可选颜色列表
                                colors:['fhf/1.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'fhf0',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg'
                                ]
                            }
                        },{
                            img:'fhf1',
                            name:i18n.t('CS55款连体防护服'),
                            type:'fhf',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("fhfText1"),
                                // 产品作用
                                use:i18n.t("fhfText2"),
                                // 可选颜色列表
                                colors:['fhf/2.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'fhf1',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg'
                                ]
                            }
                        },{
                            img:'fhf2',
                            name:i18n.t('5PP款普通防护服'),
                            type:'fhf',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("fhfText1"),
                                // 产品作用
                                use:i18n.t("fhfText2"),
                                // 可选颜色列表
                                colors:['fhf/3.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'fhf2',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg'
                                ]
                            }
                            
                        },{
                            img:'fhf3',
                            name:i18n.t('蓝色透气膜斜扁款'),
                            type:'fhf',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("fhfText1"),
                                // 产品作用
                                use:i18n.t("fhfText2"),
                                // 可选颜色列表
                                colors:['fhf/4.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'fhf3',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg'
                                ]
                            }
                        },{
                            img:'fhf4',
                            name:i18n.t('PPO5款防护服'),
                            type:'fhf',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("fhfText1"),
                                // 产品作用
                                use:i18n.t("fhfText2"),
                                // 可选颜色列表
                                colors:['fhf/5.1.png','fhf/5.2.png','fhf/5.3.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'fhf4',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg','12.jpg'
                                ]
                            }
                        },{
                            img:'fhf5',
                            name:i18n.t('CC200款防护服'),
                            type:'fhf',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("fhfText1"),
                                // 产品作用
                                use:i18n.t("fhfText2"),
                                // 可选颜色列表
                                colors:['fhf/6.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'fhf5',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg'
                                ]
                            }
                        },{
                            img:'fhf6',
                            name:i18n.t('CD款红线防护服'),
                            type:'fhf',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("fhfText1"),
                                // 产品作用
                                use:i18n.t("fhfText2"),
                                // 可选颜色列表
                                colors:['fhf/7.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'fhf6',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg'
                                ]
                            }
                        },{
                            img:'fhf7',
                            name:i18n.t('CS400款防护服'),
                            type:'fhf',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("fhfText1"),
                                // 产品作用
                                use:i18n.t("fhfText2"),
                                // 可选颜色列表
                                colors:['fhf/8.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'fhf7',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg'
                                ]
                            }
                        },{
                            img:'fhf8',
                            name:i18n.t('红色SMS外缝线防护服'),
                            type:'fhf',
                            info:{
                               // 产品简介
                               Introduction:i18n.t("fhfText1"),
                               // 产品作用
                               use:i18n.t("fhfText2"),
                                // 可选颜色列表
                                colors:['fhf/9.1.png','fhf/9.2.png','fhf/9.3.png','fhf/9.4.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'fhf8',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','9.jpg','10.jpg','11.jpg','12.jpg','13.jpg','14.jpg','15.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg'
                                ]
                            }
                        },{
                            img:'fhf9',
                            name:i18n.t('橙白拼接反光条防护服'),
                            type:'fhf',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("fhfText1"),
                                // 产品作用
                                use:i18n.t("fhfText2"),
                                // 可选颜色列表
                                colors:['fhf/10.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'fhf9',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg'
                                ]
                            }
                        }
                    ]
                },
                {
                    title: i18n.t("口罩"),
                    text: i18n.t("多种款式，专业防护"),
                    img: "ProtectionProductsClass2.jpg",
                    type:'kz',
                    child:[
                        {
                            // 在产品列表里展示图片的名称
                            img:'kz',
                            name:i18n.t('一次性多层防护口罩'),
                            type:'kz',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("kzText1"),
                                // 产品作用
                                use:i18n.t("kzText2"),
                                // 可选颜色列表
                                colors:['kz/0.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'kz',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg'
                                ]
                            }
                        }
                    ]
                },
                {
                    title: i18n.t("手术衣"),
                    text: i18n.t("多种款式，专业防护"),
                    img: "ProtectionProductsClass3.jpg",
                    type:'ssy',
                    child:[
                        {
                            // 在产品列表里展示图片的名称
                            img:'ssy1',
                            name:i18n.t('白色PP手术衣'),
                            type:'ssy',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("ssy1Text1"),
                                // 产品作用
                                use:i18n.t("ssy1Text2"),
                                // 可选颜色列表
                                colors:['ssy/0.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'ssy1',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg'
                                ]
                            }
                        },{
                            // 在产品列表里展示图片的名称
                            img:'ssy2',
                            name:i18n.t('覆膜蓝色隔离衣'),
                            type:'ssy',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("ssy2Text1"),
                                // 产品作用
                                use:i18n.t("ssy2Text2"),
                                // 可选颜色列表
                                colors:['ssy/1.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'ssy2',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg'
                                ]
                            }
                        }
                    ]
                },
                {
                    title: i18n.t("无纺布帽"),
                    text: i18n.t("多种款式，专业防护"),
                    img: "ProtectionProductsClass4.jpg",
                    type:'wfbm',
                    child:[
                        {
                            // 在产品列表里展示图片的名称
                            img:'wfbm',
                            name:i18n.t('透气膜头套'),
                            type:'wfbm',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("wfbmText1"),
                                // 产品作用
                                use:i18n.t("wfbmText2"),
                                // 可选颜色列表
                                colors:['wfbm/0.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'wfbm',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg'
                                ]
                            }
                        }
                    ]         
                },
                {
                    title: i18n.t("一次性鞋套"),
                    text: i18n.t("多种款式，专业防护"),
                    img: "ProtectionProductsClass5.jpg",
                    type:'ycxxt',
                    child:[
                        {
                            // 在产品列表里展示图片的名称
                            img:'ycxxt1',
                            name:i18n.t('一次性鞋套'),
                            type:'ycxxt',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("ycxxt1Text1"),
                                // 产品作用
                                use:i18n.t("ycxxt1Text2"),
                                // 可选颜色列表
                                colors:['ycxxt/0.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'ycxxt1',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg'
                                ]
                            }
                        },{
                            // 在产品列表里展示图片的名称
                            img:'ycxxt2',
                            name:i18n.t('透气膜革底系带靴套'),
                            type:'ycxxt',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("ycxxt2Text1"),
                                // 产品作用
                                use:i18n.t("ycxxt2Text2"),
                                // 可选颜色列表
                                colors:['ycxxt/1.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'ycxxt2',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg'
                                ]
                            }
                        }
                    ]              
                },
                {
                    title: i18n.t("防护服反光条"),
                    text: i18n.t("多种款式，专业防护"),
                    img: "ProtectionProductsClass6.jpg",
                    type:'fhfft', 
                    child:[
                        {
                            // 在产品列表里展示图片的名称
                            img:'fhfft',
                            name:i18n.t('反光条透气膜'),
                            type:'fhfft',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("fgtText1"),
                                // 产品作用
                                use:i18n.t("fgtText2"),
                                // 可选颜色列表
                                colors:['fhfft/0.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'fhfft',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg'
                                ]
                            }
                        }
                    ]                 
                },
            ]
        },
        Nursing: {
            headerImg: 'centerSlide2',
            MainTitle: i18n.t("日常防护用品"),
            miniTitle: i18n.t("健康防护 舒心生活"),
            itemList: [{
                    title: i18n.t("酒店浴袍"),
                    text: i18n.t("多种款式，专业防护"),
                    img: "DailyCareClass1.jpg",
                    type:'jdyp',
                    child:[
                        {
                            // 在产品列表里展示图片的名称
                            img:'jdyp',
                            name:i18n.t('100克珍珠纹浴袍'),
                            type:'jdyp',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("jdypText1"),
                                // 产品作用
                                use:i18n.t("jdypText2"),
                                // 可选颜色列表
                                colors:['jdyp/0.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'jdyp',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg'
                                ]
                            }
                        }
                    ]     
                },
                {
                    title: i18n.t("袖套"),
                    text: i18n.t("多种款式，专业防护"),
                    img: "DailyCareClass2.jpg",
                    type:'xt',
                    child:[
                        {
                            // 在产品列表里展示图片的名称
                            img:'xt',
                            name:i18n.t('透气膜蓝白袖套'),
                            type:'xt',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("xtText1"),
                                // 产品作用
                                use:i18n.t("xtText2"),
                                // 可选颜色列表
                                colors:['xt/0.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'xt',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg'
                                ]
                            }
                        }
                    ]   
                },
                {
                    title: i18n.t("工作服"),
                    text: i18n.t("多种款式，专业防护"),
                    img: "DailyCareClass3.jpg",
                    type:'gzf',
                    child:[
                        {
                            // 在产品列表里展示图片的名称
                            img:'gzf',
                            name:i18n.t('白色PP单领工作服'),
                            type:'gzf',
                            info:{
                                // 产品简介
                                Introduction:i18n.t("gzfText1"),
                                // 产品作用
                                use:i18n.t("gzfText2"),
                                // 可选颜色列表
                                colors:['gzf/0.png'],
                                // 这里表示存放图片文件夹的名称
                                imgUrl:'gzf',
                                // 产品详情中的 图片列表
                                img:[
                                    '0.jpg','1.jpg','2.jpg','3.jpg','4.jpg'
                                ]
                            }
                        }
                    ]   
                },
            ]
        }
    } [str]
}